import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import PhoneNumberInput from '@/atoms/input/phone-input'

import FieldWrapper from './field-wrapper'

export interface PhoneInputProps {
  label?: string
  name?: string
  countryEnum?: object
  fieldProps?: SpaceProps & WidthProps
  onChange?: (value: string) => void
  tooltip?: string
}

const PhoneInputField: FunctionComponent<PhoneInputProps> = ({ label, fieldProps, name, onChange, countryEnum, tooltip, ...rest }) => {
  const [field, meta, helpers] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error

  const handleInputChange = (value: string) => {
    helpers && helpers.setValue(value)
    onChange && onChange(value)
  }
  const handleInputBlur = (): void => {
    helpers && helpers.setTouched(true)
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} tooltip={tooltip}>
      <PhoneNumberInput
        hasError={hasError}
        value={field.value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        countryEnum={countryEnum}
        {...rest}
      />
    </FieldWrapper>
  )
}

PhoneInputField.displayName = 'PhoneInputField'

export default PhoneInputField
